module.exports = __webpack_public_path__ + "img/akinder_loading.72a1f443.gif";